import 'core-js/stable'
import Vue from 'vue'
import App from './App'
import router from './router'
import CoreuiVue from '@coreui/vue'
import 'regenerator-runtime';
import { iconsSet as icons } from './assets/icons/icons.js'
import store from './store'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faWifi,faCogs,faComments,faCommentDots,faPhone,faMicrophone,faSms,faPhoneSquare,faCompress,faExpand,faLink,faTag,faCheckCircle,faBusAlt,faGripLines,faDrawPolygon,faUser,faInfoCircle } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import fullscreen from 'vue-fullscreen'
import VueSession from 'vue-session'
import { LMap, LTileLayer, LMarker, LPopup, LTooltip , LIcon,LPolyline ,LPolygon,LControlLayers,LControlZoom,LControl,LFeatureGroup ,LWMSTileLayer} from 'vue2-leaflet';
import 'leaflet/dist/leaflet.css';
import VuePersianDatetimePicker from 'vue-persian-datetime-picker';
import VueHtmlToPaper from 'vue-html-to-paper';
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';
import axios from 'axios'
import VueAxios from 'vue-axios'
import JsonExcel from "vue-json-excel";
import MLoading from '@/views/Themes/MLoading.vue'
import MCHart from '@/views/Themes/MCHart.vue'
import MCHartPie  from '@/views/Themes/MCHartPie.vue'
import MPrint from '@/views/Themes/MPrint.vue'
import LDrawToolbar from 'vue2-leaflet-draw-toolbar'

// ...
Vue.component('l-draw-toolbar', LDrawToolbar);
Vue.component("MLoading", MLoading);
Vue.component("MCHart", MCHart);
Vue.component("MCHartPie", MCHartPie);
Vue.component("MPrint", MPrint);
Vue.component("downloadExcel", JsonExcel);
Vue.use(VueAxios, axios);
Vue.component('loading',Loading);
Vue.use(VueHtmlToPaper, {
  "name": "_blank",
  "specs": [
    "fullscreen=no",
    "titlebar=no",
    "scrollbars=no"
  ],
  "styles": [
    "//unpkg.com/bootstrap/dist/css/bootstrap.min.css",
    "//unpkg.com/bootstrap-vue@latest/dist/bootstrap-vue.min.css",
    "http://localhost:8081/css/Style.css"
  ],
  "timeout": 1000,
  "autoClose": true,
  "background": "#f00",

  "windowTitle": "Vue Html To Paper - Vue mixin for html elements printing."
});
Vue.use(VueHtmlToPaper);
Vue.component('date-picker', VuePersianDatetimePicker);
Vue.component('l-map', LMap);
Vue.component('l-tile-layer', LTileLayer);
Vue.component('l-marker', LMarker);
Vue.component('l-popup', LPopup);
Vue.component('l-icon', LIcon);
Vue.component('l-polyline', LPolyline);
Vue.component('l-polygon', LPolygon);
Vue.component('l-control-layers', LControlLayers);
Vue.component('l-control-zoom', LControlZoom);
Vue.component('l-control', LControl);
Vue.component('l-feature-group', LFeatureGroup);
Vue.component('l-wms-tile-layer', LWMSTileLayer);
Vue.use(require('vue-jalali-moment'));
Vue.use(VueSession)
import PersianCalendar from 'vue-persian-calendar';
Vue.component('persian-calendar',PersianCalendar)
//Vue.use(VueSession, options)
Vue.use(fullscreen)
library.add(faWifi,faCogs,faComments,faCommentDots,faPhone,faMicrophone,faSms,faPhoneSquare,faCompress,faExpand,faLink,faTag,faCheckCircle,faBusAlt,faGripLines,faDrawPolygon,faUser,faInfoCircle)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)
Vue.config.performance = true
Vue.use(CoreuiVue)
Vue.prototype.$log = console.log.bind(console)



new Vue({
  el: '#app',
  router,
  store,
  icons,
  template: '<App/>',
  components: {
    App
  }
})
